import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import BrandImage from 'mbs-ui-shared@models/BrandImage';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BrandsImagesService {
  private baseHref = (id: string) => `/api/brands/${id}/images`;
  private dataHref = (id: string) => `${this.baseHref(id)}/data`;

  constructor(private http: HttpClient) {}

  get(brandId: string): Observable<BrandImage[]> {
    return this.http.get<BrandImage[]>(this.baseHref(brandId));
  }

  update(brandId: string, data: BrandImage[]): Observable<any> {
    return this.http.put(this.dataHref(brandId), data);
  }

  add(brandId: string, formData: FormData): Observable<any> {
    return this.http.post(this.dataHref(brandId), formData);
  }
}
